<template>
  <div class="field">
    <b-tooltip animated :label="getLabel" multilined>
      <div class="pill" draggable="true" @dragover.prevent @dragstart="mydragstart">
        <b-tag rounded v-if="isTag1Active" type="is-primary" closable @close="removeClaimClick()">{{
          claim.name
        }}</b-tag>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
import Mixin from '../../mixins/mixin.js'
import rmBtnMixin from '../../mixins/rmBtnMixin.js'

export default {
  mixins: [Mixin, rmBtnMixin],
  props: {
    claim: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isTag1Active: true
    }
  },

  computed: {
    getLabel: function() {
      return `Projectid: ${this.claim.projectId}
      Adres: ${this.claim.address}
      Plaats: ${this.claim.city}`
    }
  },

  methods: {
    removeClaimClick() {
      const targetLevel = 'noAccess'
      const item = this.claim
      const rechten = this.claimsFormEnglishToDutch(targetLevel)
      const user = this.$store.getters.selectedUser
      this.popup(rechten, user, item, targetLevel, false)
    },
    mydragstart(e) {
      e.dataTransfer.setData('data', JSON.stringify(this.claim))
    }
  }
}
</script>

<style lang="scss">
.tooltip:not([data-label='']):hover:before,
.tooltip:not([data-label='']):hover:after {
  transition-delay: 0.5s;
}

.tooltip.is-multiline:after {
  font-size: 11px;
  white-space: pre-line;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/PillItem.vue